import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserRatingApi } from "../../services/user-rating.api";
import { IonButton, IonContent, IonHeader, IonTitle, IonToolbar, ModalController } from "@ionic/angular/standalone";
import { UserRating } from "../../interface/user-rating.interface";
import { User } from '../../../user';
import { PaginatedResponse } from "@qid/core";
import { SexyModule } from '@qid/sexy';
import { AvatarRoundComponent } from '@qid/super';

@Component({
  selector: 'view-user-rating',
  templateUrl: './view-user-rating.page.html',
  styleUrls: ['./view-user-rating.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    AvatarRoundComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonContent
  ]
})
export class ViewUserRatingPage {

  @Input() user: User;

  public paginatedRatings: PaginatedResponse<UserRating> = null

  constructor(
    private userRatingApi: UserRatingApi,
    private modalController: ModalController
  ) {
  }


  async ionViewDidEnter() {
    this.fetchUserRatings();
  }


  async fetchUserRatings(page: number = 1) {
    const res = await this.userRatingApi.read(this.user._id, page)
    if (res && res.data) {
      this.paginatedRatings = res.data
    }
  }

  closeModal() {
    this.modalController.dismiss()
  }

}
